document.addEventListener('DOMContentLoaded', function () {
    var footer = document.querySelector('.site-footer');
    if (!footer) return;

    var reveals = Array.prototype.slice.call(
        footer.querySelectorAll('.site-footer__brand, .site-footer__col')
    );

    if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
            function (entries, obs) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        var delay = Array.prototype.indexOf.call(reveals, entry.target) * 90;
                        window.setTimeout(function () {
                            entry.target.classList.add('is-visible');
                        }, delay);
                        obs.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.15 }
        );

        reveals.forEach(function (el) {
            observer.observe(el);
        });
    } else {
        reveals.forEach(function (el) {
            el.classList.add('is-visible');
        });
    }

    var accordionItems = Array.prototype.slice.call(
        footer.querySelectorAll('[data-footer-accordion]')
    );
    if (!accordionItems.length) return;

    var mobileQuery = window.matchMedia('(max-width: 599px)');
    var isMobile = mobileQuery.matches;

    var setAccordionState = function (item, expanded) {
        var trigger = item.querySelector('[data-footer-accordion-trigger]');
        var panel = item.querySelector('[data-footer-accordion-panel]');
        if (!trigger || !panel) return;

        item.classList.toggle('is-open', expanded);
        trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');
    };

    accordionItems.forEach(function (item) {
        var trigger = item.querySelector('[data-footer-accordion-trigger]');
        if (!trigger) return;

        setAccordionState(item, !isMobile);
        trigger.addEventListener('click', function () {
            if (!isMobile) return;

            setAccordionState(item, trigger.getAttribute('aria-expanded') !== 'true');
        });
    });

    window.addEventListener('resize', function () {
        var nextIsMobile = mobileQuery.matches;
        if (nextIsMobile === isMobile) return;

        isMobile = nextIsMobile;
        accordionItems.forEach(function (item) {
            setAccordionState(item, !isMobile);
        });
    });
});
